export default (fieldValue,fieldName,label) => {
  fieldValue = fieldValue && fieldValue.trim ? fieldValue.trim() : fieldValue;
  return {
    valid:
      fieldValue !== null && fieldValue !== "" && (Array.isArray(fieldValue) && fieldValue.length > 0 || !Array.isArray(fieldValue)) && fieldValue !== "Invalid Date" && typeof fieldValue !== 'undefined',
    validationText: "שדה "+ label +" זה הינו חובה "
  };
};
